import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, map, of } from "rxjs";
import { IUser, User } from "src/app/models/Identity/user";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { environment } from "src/environments/environment";
import { IQRCompartido } from "src/app/misQr/interfaces/share-qr.interface";

@Injectable({
  providedIn: "root",
})
export class ShareQrServiceService {
  sharedQRURL = `${environment.apiUrlCap}/api/QrCompartido/usuario/4`;

  constructor(private http: HttpClient) {}

  getQRBySesion(
    idLocalizador: number,
    userId: number
  ): Observable<IQRCompartido[]> {
    const params = new HttpParams();

    params.append("usuarioDestino", userId);
    params.append("idLocalizador", idLocalizador);

    return this.http
      .get<ResponseDataInterfaces<IQRCompartido[]>>(`${this.sharedQRURL}`, {
        params,
      })
      .pipe(
        map(({ data }) => data),
        catchError(err => of([]))
      );
  }
}
